/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';
import DisableButton from './components/disable';

import { BlockItemContainer, BlockItemHead, BlockTitle } from '../../css';
import FormControlPanel from './components/formControlPanel';

const BlockItem = ({ data, fetchData }) => {
  const { outlet, formTypes, is_outlet_disabled } = data;
  return (
    <BlockItemContainer isDisabled={is_outlet_disabled}>
      <BlockItemHead>
        <BlockTitle isDisabled={is_outlet_disabled}>{outlet}</BlockTitle>
        <div>
          <DisableButton
            name={outlet || 'null'}
            fetchData={fetchData}
            isDeleted={is_outlet_disabled}
          />
        </div>
      </BlockItemHead>
      <FormControlPanel
        id={outlet}
        formTypes={formTypes}
        isDeleted={is_outlet_disabled}
        fetchData={fetchData}
      />
    </BlockItemContainer>
  );
};

BlockItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    outlet: PropTypes.string,
    formTypes: PropTypes.shape({
      disableBrp: PropTypes.bool,
      disableReferral: PropTypes.bool,
      disableWireless: PropTypes.bool,
      disableVulcan: PropTypes.bool
    }),
    is_outlet_disabled: PropTypes.bool
  }).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default BlockItem;
